import articlesSlider from './articles-slider';

function initFilters() {

  $('.sh-filter-select').each(function () {
    const select = $(this);
    const selectHeader = select.find('.sh-select-header');
    const options = select.find('.sh-options');


    selectHeader.click(function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      $('.sh-options').hide();
      $('.sh-select-header').removeClass('active');
      $(this).addClass('active');


      if ($('.sh-tab-icons').is(':visible')) {
        const positionTop = $('.sh-filters').offset().top - $(window).scrollTop() + $('.sh-filters').outerHeight();
        options.slideToggle('slow', function () {
          options.css({
            'top': `${positionTop}px`,
          })
        });
      } else
        options.slideToggle();
    });

    options.find('li').click(function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation()
      selectHeader.find('span').text($(this).text());
      options.slideUp();
    });

  });


  $(document).on('click', function (event) {
    if (!$(event.target).closest('.sh-filter-select').length) {
      $('.sh-options').slideUp();
      $('.sh-select-header').removeClass('active');
    }

    if (!$(event.target).closest('.sh-search').length && $('#sh-filter-search').val() === '') {
      $('.sh-search').removeClass('active');
    }
  });
}

function initFilterPopup() {
  let currentStep = 0;
  let selectedFilters = {};
  const currentProductId = window.currentProductId
  const filterPopupData = window.filterPopupData;
  if (!filterPopupData)
    return;

  $(document).ready(function () {

    const currentStorage = JSON.parse(sessionStorage.getItem('sh-filter-popup-products')) || [];

    if ((currentStorage && currentStorage.indexOf(currentProductId) !== -1) || filterPopupData.length === 0) {
      $('.sh-filter-popup').hide();
      return;
    } else
      $('.sh-filter-popup').show();


    $('.sh-filter-popup-paging').empty();
    filterPopupData.map((item, index) => {
      $('.sh-filter-popup-paging').append(`<span class="sh-filter-popup-page ${index === 0 ? 'active' : ''}"/>`);
    });

    updatePopupData();
  });


  const updatePopupData = () => {
    $('.sh-filter-popup-question').text(filterPopupData[currentStep].question);
    $('.sh-filter-popup-btn').remove();

    if (currentStep === 0) {
      $('.sh-filter-popup-btn-back').hide();
    } else {
      $('.sh-filter-popup-btn-back').show();
    }

    filterPopupData[currentStep].answers.forEach(answer => {
      $('.sh-filter-popup-buttons').append(`<span class="sh-filter-popup-btn" data-value="${answer.value}">${answer.title}</span>`);
    });

    $('.sh-filter-popup-page').removeClass('active');
    $('.sh-filter-popup-page').eq(currentStep).addClass('active');

  }

  const applyFilters = () => {

    Object.keys(selectedFilters).map(ind => {
      const filter = selectedFilters[ind];
      if (!filter.keys)
        return

      if (filter.type === 'features') {
        filter.keys.map(key => {
          document.getElementById(key).click();
        });
      }

      if (filter.type === 'groupSize') {
        $('.sh-group-size-input').val(filter.keys);
        $('.sh-group-size-input').keypress();
      }

    });

    $('.sh-group-size .sh-button-primary').click();
    closePopup(true);
  }


  $(document).on('click', '.sh-filter-popup-btn', function () {

    let filterValue = !$(this).data('value') ? false : filterPopupData[currentStep].keys;
    if (filterPopupData[currentStep].type === 'groupSize') {
      filterValue = $(this).data('value');
    }

    selectedFilters[currentStep] = {
      type: filterPopupData[currentStep].type,
      keys: filterValue,
    };


    if (currentStep === filterPopupData.length - 1) {
      applyFilters();
      return;
    }

    if (currentStep <= filterPopupData.length - 1) {
      currentStep++;
      updatePopupData();
    }

  });

  const closePopup = (skipStorage = false) => {
    $('.sh-filter-popup').hide();
    if (skipStorage)
      return;

    const currentStorage = JSON.parse(sessionStorage.getItem('sh-filter-popup-products')) || [];
    currentStorage.push(currentProductId);
    sessionStorage.setItem('sh-filter-popup-products', JSON.stringify(currentStorage));
  }


  $(document).on('click', '.sh-filter-popup-btn-back', function () {
    if (currentStep > 0) {
      currentStep--;
      updatePopupData();
    }
  });

  $(document).on('click', '.sh-filter-popup-close', function () {
    closePopup();
  });
}

function initCompareVendors() {
  let comparingVendors = [];
  let vendorLogos = {};
  showCompareVendors();
  $('#sh-compare-reset').click();
  $('#sh-compare-btn .spinner').addClass('sh-hidden');

  $(document).on('click', '#sh-compare-btn', function () {

    $('#sh-compare-btn').find('.spinner').removeClass('sh-hidden');
    let vendorsToCompare = [];
    comparingVendors.map(item => vendorsToCompare.push({slug: item}))
    post('/' + $('#product-slug').val() + '/compare', {
      vendors: vendorsToCompare,
    });
  });

  function post(path, parameters) {
    let form = $('<form></form>');

    form.attr('method', 'post');
    form.attr('action', path);

    $.each(parameters, function (key, value) {
      var field = $('<input></input>');

      field.attr('type', 'hidden');
      field.attr('name', key);
      field.attr('value', JSON.stringify(value));

      form.append(field);
    });

    //The form needs to be a part of the document in
    //order for us to be able to submit it.
    $(document.body).append(form);
    form.submit();
  }

  $('#sh-compare-reset').on('click', function () {
    comparingVendors = [];
    showCompareVendors();
    $('.sh-checkbox-input.sh-vendor-compare').prop('checked', false);
    $('.sh-compare-settings, .sh-compare-settings a, .sh-checkbox').removeClass('active');

  })

  function showCompareVendors() {
    $('.sh-compare-box .sh-compare-vendor-picture').attr('src', '');
    $('.sh-compare-box .sh-box-delete').hide();
    $('.sh-card').removeClass('checked');

    comparingVendors.map((item, index) => {
      $('.sh-compare-box').eq(index).find('.sh-compare-vendor-picture').attr('src', vendorLogos[item]);
      $('.sh-compare-box').eq(index).find('.sh-box-delete').show();
      $('.sh-compare-box').eq(index).find('.sh-box-delete').attr('data-vendor', item);
      $(`.sh-card[data-vendor="${item}"]`).addClass('checked');
    });

    if (comparingVendors.length > 0)
      $('#sh-compare-wrap').addClass('active');
    else
      $('#sh-compare-wrap').removeClass('active');
  }

  $('.sh-box-delete').on('click', function () {
    const vendorSlug = $(this).data('vendor');
    comparingVendors.splice(comparingVendors.indexOf(vendorSlug), 1);
    showCompareVendors();
    $(`#compare-${vendorSlug}`).prop('checked', false);
  });

  $('.sh-vendor-list-container').on('click', '.sh-vendor-compare', function () {
    const vendorSlug = $(this).data('vendor-slug');

    if (this.checked && comparingVendors.length < 3) {
      comparingVendors.push(vendorSlug);
      vendorLogos[vendorSlug] = $(`[data-vendor-logo="${vendorSlug}"] img`).attr('src');
      showCompareVendors();
    } else if (this.checked && comparingVendors.length === 3) {
      this.checked = false;
    }

    if (!this.checked && comparingVendors.includes(vendorSlug)) {
      comparingVendors.splice(comparingVendors.indexOf(vendorSlug), 1);
      showCompareVendors();
    }
  })

  $(document).on('click', '.sh-compare-settings a', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.sh-checkbox').addClass('active');
    const vendorSlug = $(this).data('vendor');
    $(`.sh-checkbox input[data-vendor="${vendorSlug}"]`).click()
  })
  $(document).on('click', '.sh-button-compare-settings', function (e) {
    e.preventDefault();
    $(this).parent().find('.sh-compare-settings').toggleClass('active');
  });
  $(document).on('click', function (event) {
    if (!$(event.target).closest('.sh-button-compare-settings').length) {
      $('.sh-compare-settings').removeClass('active');
    }
  });
}

//List Container change. Just uncomment if needed
/*function initListContainerChangeEvent() {
  //Reset Container
  var targetNode = document.querySelector('.sh-vendor-list-container');

  var observer = new MutationObserver(function() {
    $('#sh-compare-reset').click();
  });

  var config = { subtree: true, childList: true };
  observer.observe(targetNode, config);

// observer.disconnect();
}*/

function initTabs() {
  $('.sh-vendor-list-header-menu li').click(function () {
    $('#sh-all-vendor, #sh-top-vendor, #sh-vendor-list-filters-section').hide();
    $('.sh-vendor-list-header-menu li').removeClass('active');
    $(this).addClass('active');
    const activeTab = $(this).data('tab');
    $(`#sh-${activeTab}-vendor`).show();
    if (activeTab === 'all')
      $('.sh-tabs-actions').show();
    else
      $('.sh-tabs-actions').hide();
  });

  $(document).on('click', '.sh-enable-filters', function () {
    $(this).toggleClass('active');
    $('#sh-vendor-list-filters-section').toggle();

  })
}

function topVendorsAnchors() {
  $('.top-vendor-list li').click(function () {
    const scrollTo = $(this).data('to');
    $([document.documentElement, document.body]).animate({
      scrollTop: $(scrollTo).offset().top,
    }, 800);

    $('.top-vendor-list li').removeClass('active');
    $(this).addClass('active');
  })
}

function initCardTabs() {
  if ($(window).width() < 1182) {
    $('.sh-vendor-list-container .sh-card-tabs .sh-tab-header').removeClass('active');
  }

  $(window).resize(function () {
    if ($(window).width() < 1182) {
      $('.sh-vendor-list-container .sh-card-tabs .sh-tab-header').removeClass('active');
    }
  });

  $('.sh-vendor-list-container').on('click', '.sh-card-tabs .sh-tab-header', function () {
    const tab = $(this);
    const activeTab = tab.data('tab');

    //if mobile
    if ($(window).width() < 1182) {
      tab.toggleClass('active');
      tab.parent().parent().find(activeTab == 2 ? '.sh-tab-company' : '.sh-tab-product').toggleClass('active-tab');
    } else {
      tab.parent().find('.sh-tab-header').removeClass('active');
      tab.addClass('active');

      tab.parent().parent().find('.sh-tab-company, .sh-tab-product').hide();
      tab.parent().parent().find(activeTab == 2 ? '.sh-tab-company' : '.sh-tab-product').show();
    }
  })
}

function initClickCompare() {
  $('.preselectCompare').click();
}

export default {
  init() {
    initFilters();
    initTabs();
    topVendorsAnchors();
    initCompareVendors();
    initCardTabs();
    initFilterPopup();
    initClickCompare();
    articlesSlider.init();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
